// Import assets
import type { ProductData } from "assets/types";

export const emptyProductData: ProductData = {
  id: "-",
  nombre: "-",
  presentacion: "-",
  formula: "-",
  descripcion: "-",
  modoDeUso: "-",
  precio: "-",
};
